import styled from 'styled-components'

import { media, mediaMax } from '../../../styles/media'

import { Content } from '../../cards/shared/styled'
import {
  heightLarge as navbarHeightLarge,
  heightSmall as navbarHeightSmall,
  navbarSizeBreakpoint as navbarBreakpoint,
} from '../../../layout/Navbar/constants'

import { Grid, GridItem } from '../ItemGrid'

export const Outerwrapper = styled.div``

export const MobileSearchViewWrapper = styled.div`
  position: relative;
  padding-bottom: 88px;
`

export const ResultsWrapper = styled.div`
  padding-top: 24px;

  ${Grid} {
    ${media.sm`
    margin: 0;
    padding-left: 8px;
    padding-right: 8px;

    ${Content} {
    padding-left: 0 !important;
    padding-right: 0 !important;
    }
  `}
  }

  ${GridItem} {
    width: 100%;

    ${media.sm`
      width: 50%;
      padding: 0 16px;
    `}

    ${media.lg`
      width: 33.333%;
    `}
  }
`

type MapWrapperProps = {
  $offsetForNavbar?: boolean
}

export const MapWrapper = styled.div<MapWrapperProps>`
  position: fixed;
  left: 0;

  ${mediaMax[navbarBreakpoint]<MapWrapperProps>`
    top: ${({ $offsetForNavbar }) =>
      $offsetForNavbar ? `${navbarHeightSmall}px` : '0px'};
    height: ${({ $offsetForNavbar }) =>
      `calc(100% - ${$offsetForNavbar ? navbarHeightSmall : 0}px)`};
  `}

  ${media[navbarBreakpoint]<MapWrapperProps>`
    top: ${({ $offsetForNavbar }) =>
      $offsetForNavbar ? `${navbarHeightLarge}px` : '0px'};
    height: ${({ $offsetForNavbar }) =>
      `calc(100% - ${$offsetForNavbar ? navbarHeightLarge : 0}px)`};
  `}

  width: 100%;
`

export const MobileFilters = styled.div`
  width: 100%;
  background-color: white;

  z-index: 1;
`

export const StickyMobileFilters = styled(MobileFilters)`
  position: -webkit-sticky;
  position: sticky;

  ${mediaMax[navbarBreakpoint]`
     top: ${navbarHeightSmall}px;
  `}

  ${media[navbarBreakpoint]`
    top: ${navbarHeightLarge}px;
  `}
`

export const MobileFiltersOuter = styled.div`
  background-color: ${({ theme }) => theme?.['-ds-neutral-100']?.value};
  border-bottom: 1px solid #d3d3d3;
`

export const MobileFiltersInner = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 0;
  overflow-x: auto;
  scrollbar-width: none;

  & > * {
    margin-right: 8px;
    flex: 0 0 auto;

    &:first-child:not(:last-child) {
      margin-left: 16px;
    }

    &:last-child {
      margin-right: 0;
    }
  }
`
